module.exports = __webpack_public_path__ + "img/57047990-2e26-4b44-bacf-f10bca5ee70d.f4e9c6ac.webp";